<template>
    <div class="systemTypeBloc">
        <SystemTypeIcon :type="systemTypeId" />
        <h3>{{ $t(`systemTypes.${systemTypeId}`) }}</h3>
    </div>
</template>

<script>
import SystemTypeIcon from "@/components/planoList/SystemTypeIcon";

export default {
    components: { SystemTypeIcon },
    props: {
        systemTypeId: {
            type: Number,
            required: true
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../../../../assets/css/themes";

.systemTypeBloc {
    position: relative;
    width: 500px;
    cursor: pointer;
    margin: 15px auto;
    border: 1px #000 solid;
    @extend %primary-border-color;
    padding: 10px;
    opacity: 1;
    transition: all 0.3s ease;

    div:first-child {
        position: absolute;
        left: 0;
        top: 5px;
        > :first-child {
            height: 60px;
        }
    }

    img {
        width: 30px;
        float: left;
        vertical-align: middle;
    }
    h3 {
        display: inline-block;
        vertical-align: middle;
        text-transform: uppercase;
        font-size: 25px;
        font-family: Oswald;
        margin: 10px 0px;
        font-weight: normal;
        @extend %primary-text;
    }
    &:hover,
    &.active {
        opacity: 1;
        @extend %primary-background;
    }
}
</style>



// WEBPACK FOOTER //
// system-type-item.vue?f9fe09ec